export default "//file.bilionpass.com/japandx-portal/0.1.15/static/img/cloud-05.6b5404b8-c1e73f.svg";